export const rule: any = [
  {
    label: '姓名*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入姓名',
    title: '',
    value: 'name',
    max: 50,
  },
  {
    label: '电话*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入联系方式',
    title: '',
    value: 'phone',
    max: 50,
  },
  {
    label: '所属单位*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入单位名称',
    title: '',
    value: 'company',
    max: 50,
  },
  {
    label: '作品类型*',
    require: true,
    type: 'picker',
    columns: ['图文作品', '视频作品'],
    placeholder: '请选择类型',
    title: '',
    value: 'work_type',
    max: 50,
  },
  {
    label: '作品标题*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入作品标题',
    title: '',
    value: 'title',
    max: 50,
  },
];
export let field: any = {
  name: '',
  phone: '',
  company: '',
  work_type: '',
  title: '',
};

export const fieldCopy: any = {
  name: '',
  phone: '',
  company: '',
  work_type: '',
  title: '',
};
